import React from 'react';
import { Button, Typography, Container, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // שימוש ב-useNavigate

const Conditions = () => {
  const navigate = useNavigate(); // יצירת אובייקט ניווט

  const handleHomeClick = () => {
    navigate('/'); // ניווט לדף הבית
  };

  const handleContinueShoppingClick = () => {
    navigate('/products'); // ניווט לדף המוצרים
  };

  return (
<Container
  maxWidth="md"
  sx={{
    direction: "rtl",
    textAlign: "right",
    py: 4,
  }}
>
  <Typography
    variant="h4"
    fontWeight="bold"
    gutterBottom
    sx={{
      color: "#58A76B",
      textAlign: "center",
      mb: 3,
    }}
  >
    תנאי חברת שיינס סטוק
  </Typography>

  <Typography
    sx={{
      mb: 4,
      lineHeight: 2,
      fontWeight: 500,
      textAlign: "center",
    }}
  >
    אנא קראו דף זה בעיון לפני ביצוע הזמנתכם
  </Typography>

  <Typography
    variant="h5"
    fontWeight="bold"
    sx={{
      color: "#58A76B",
      borderBottom: "2px solid #58A76B",
      pb: 1,
      mb: 2,
      mt: 4,
    }}
  >
    מחירים ואחריות המוצר
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
   במקרה שבו קיימת אי־התאמה בין תיאור המוצר המופיע באתר לבין התמונה המצורפת 
    התיאור הכתוב הוא הקובע והמחייב.
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    המוצרים המוצעים באתר זה ומחיריהם בתוקף לגבי המלאי הקיים בלבד.
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
החברה שומרת לעצמה את הזכות לעדכן את מחירי המוצרים בכל עת וללא הודעה מוקדמת.
 המחיר שיחול על ההזמנה יהיה המחיר שהופיע באתר במועד השלמת ההזמנה ואישור התשלום.
 אם חל שינוי במחיר לפני השלמת ההזמנה, יחול המחיר המעודכן.
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    לתשומת לבך: למרות שאנו מקפידים לבדוק את המחירים המופיעים באתר, לעיתים עלולה
    לחול טעות שבעקבותיה יוצג באתר מחיר שגוי. במקרה זה אנו רשאים לפנות אליך לאחר
    שביצעת את הזמנתך, להודיע לך מהו המחיר הנכון של המוצר, ולאפשר לך לאשר כי אתה
    מבקש לרוכשו במחיר הנכון. אם תסרב לרכוש את המוצר במחירו הנכון – לא נהיה חייבים
    לספקו לך ובמקרה זה לא תהיינה לך טענות כלפי החברה .
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
החברה רשאית להפעיל באתר מבצעים, הנחות והטבות שונות, וכן לעדכנם, לשנותם או להפסיקם בכל עת,
 לפי שיקול דעתה הבלעדי וללא הודעה מוקדמת.
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
   תמונות המוצרים באתר מוצגות לצורכי המחשה בלבד. ייתכנו הבדלים בין התמונות לבין המוצר בפועל, 
   לרבות בגוון, בצבע, בגודל או במראה, כתוצאה מהבדלי תצוגה במסכים שונים או משינויים שמבצעים היצרנים מעת לעת.
    הבדלים אלו אינם מהווים פגם במוצר ולא יקנו עילה לטענה כלפי החברה.
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    שיינס סטוק אינה מתחייבת כי מחיר המוצר באתר ו/או בחנות יהיה זהה, וכן ייתכנו
    מבצעים מיוחדים ונפרדים לאתר ו/או לחנות.
  </Typography>
    <Typography
    variant="h5"
    fontWeight="bold"
    sx={{
      color: "#58A76B",
      borderBottom: "2px solid #58A76B",
      pb: 1,
      mb: 2,
      mt: 5,
    }}
  >
    ביטול עסקה ומדיניות החזרת מוצרים
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    על הלקוח לבדוק את המוצר מיד עם קבלתו. במקרה שבו התקבל מוצר
    פגום, או כאשר קיימת אי־התאמה בין המוצר שהתקבל לבין הפרטים
    שפורסמו באתר,רשאי הלקוח לבטל את העיסקה תוך 14 ימי עסקים 
    על ידי הודעת  ביטול באמצעות שיחה טלפונית למספר  - 025853000 .
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    ביטול עסקה יתבצע בהתאם להוראות חוק הגנת הצרכן,
    התשמ"א–1981, והתקנות שהותקנו מכוחו. הפירוט המופיע בעמוד זה
    נועד לנוחות הלקוחות בלבד ואינו מחליף את הוראות החוק. בכל
    מקרה של סתירה בין האמור בעמוד זה לבין הוראות החוק, יגברו
    הוראות החוק.
  </Typography>

  

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    במקרה של ביטול עסקה שלא עקב פגם במוצר או אי־התאמה, על
    הלקוח להחזיר את המוצר באריזתו המקורית, כשהוא שלם, ללא
    שימוש, פגם או נזק, למעט פתיחת האריזה ובדיקה סבירה של
    המוצר. החזרת המוצר תתבצע על חשבון הלקוח לכתובת מאה שערים
    7, ירושלים, ולאחר תיאום מראש עם החברה.
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    עלות החזרת המוצר תחול על הלקוח, למעט במקרים שבהם הביטול
    נובע מפגם, אי־התאמה או הפרה אחרת מצד החברה,
    בכל מקרה לא יוחזרו דמי המשלוח, ואם המשלוח היה בחינם ינוכה מחיר המשלוח מהסכום הזיכוי
    אין החזרה על מוצרים עונתיים, מוצרי נייר ומוצרים בהזמנה אישית
   
  </Typography>



  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    החזר כספי יבוצע לאמצעי התשלום שבו בוצעה העסקה, בהתאם
    להוראות הדין ולאפשרויות חברת הסליקה. במקרים שבהם לא ניתן
    לבצע את ההחזר לאותו אמצעי תשלום, החברה תתאם עם הלקוח דרך
    חלופית לביצוע ההחזר.
  </Typography>

  <Typography
    variant="h5"
    fontWeight="bold"
    sx={{
      color: "#58A76B",
      borderBottom: "2px solid #58A76B",
      pb: 1,
      mb: 2,
      mt: 5,
    }}
  >
    תנאי אספקת מוצרים
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    שיינס סטוק שומרת לעצמה את הזכות, לפי שיקול דעתה הבלעדי, שלא לספק מוצר מסוים
    במידה והמוצר אזל מהמלאי. במקרה כזה תודיע החברה ללקוח על ביטול העסקה או תציע
    לו מוצר חלופי.
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    שיינס סטוק לא תהיה אחראית לכל איחור או עיכוב באספקה ו/או לאי אספקה שנגרמו
    כתוצאה מכוח עליון ו/או מאירועים שאינם בשליטתה.
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    האפשרות להזמין מוצרים באתר מוגבלת לאזורים בארץ ובהתאם למפת אזורי החלוקה של
    דואר ישראל או חברת המשלוחים. החברה רשאית, אך לא חייבת, לספק מוצרים גם מחוץ
    לאזורי החלוקה, בתיאום ובתמחור נפרד מול הלקוח מראש.
  </Typography>
    <Typography
    variant="h5"
    fontWeight="bold"
    sx={{
      color: "#58A76B",
      borderBottom: "2px solid #58A76B",
      pb: 1,
      mb: 2,
      mt: 5,
    }}
  >
    שירות לקוחות
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    המטרה שלנו היא להעניק לכל לקוח שירות מקצועי, אדיב וזמין.
    אם יש לכם שאלות בנוגע למוצרים, להזמנה שביצעתם, למשלוח,
    למלאי או לכל נושא אחר – צוות שירות הלקוחות של
    <strong> שיינס סטוק </strong>
    ישמח לעמוד לרשותכם.
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    ניתן ליצור עמנו קשר באמצעות:
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 1 }}>
    <strong>טלפון:</strong> 02-5853000
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    <strong>דוא"ל:</strong> t025853000@gmail.com
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    אנו עושים כל מאמץ להעניק מענה מהיר, מקצועי ואדיב לכל פנייה,
    ומלווים את לקוחותינו לאורך כל תהליך הרכישה – החל מבחירת
    המוצרים ועד לקבלת ההזמנה. שביעות רצון הלקוחות היא בראש סדר
    העדיפויות שלנו, ונשמח לעמוד לשירותכם בכל שאלה או בקשה.
  </Typography>

  <Typography
    variant="h5"
    fontWeight="bold"
    sx={{
      color: "#58A76B",
      borderBottom: "2px solid #58A76B",
      pb: 1,
      mb: 2,
      mt: 5,
    }}
  >
    תנאים נוספים
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    אם נפלה טעות סופר בתיאור מוצר או במחיר כלשהו, לא יחייב הדבר את החברה.
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    רישומי המחשב של החברה יהוו ראיה לכאורה לנכונות הפעולות שבוצעו באתר.
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
 החברה עושה מאמצים לספק שירות איכותי, אמין ומקצועי לכלל משתמשי האתר. בכפוף להוראות הדין,
  החברה ו/או מי מטעמה לא יישאו באחריות לכל נזק, ישיר או עקיף, העלול להיגרם כתוצאה מהשימוש באתר או מהסתמכות על המידע המופיע בו.
  
  </Typography>
    <Typography sx={{ lineHeight: 2, mb: 2 }}>
     אנו מתחייבים לא להעביר את פרטי האשראי של הלקוח לצד ג 
  </Typography>

  <Typography sx={{ lineHeight: 2, mb: 2 }}>
    השימוש באתר מהווה הסכמה מלאה לכל התנאים המפורטים בדף זה.
  </Typography>
</Container>
  );
};

export default Conditions;
